import React, { useState, useEffect } from 'react';
import styles from '../InternalAdminTool.module.scss';
import { Button, Input, Label, DropDownNative } from '@tag/tag-components-react-v4';
import { ProjectAccents } from "../../../General/config/projectAccents";

interface SearchFormProps {
  onSearch: (clientId: string) => void;
  accClient: string;
  setAccClient: (clientId: string) => void;
}

const SearchForm: React.FC<SearchFormProps> = ({ onSearch, accClient, setAccClient }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(accClient);
  };

  return (
    <>
      <div className={styles.formContainer}>        
        <form className={styles.form} onSubmit={handleSearch}>
          <div>
            <Input
              id="accClient"
              value={accClient}
              onChange={e => setAccClient(e.target.value)}
              placeholder="Enter ACC Client ID"
            />
          </div>
          
          <Button 
            type="submit" 
            accent={ProjectAccents.CareCompliance}
          >
            Search
          </Button>
        </form>
      </div>
      
      <div className={styles.info}>
        Search for the ACC customer you want to connect to the Workspace Organisation
      </div>
    </>
  );
};

export default SearchForm;
